/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { sachsoServerUrl } from 'constants/serverUrls';
import { APPLICATION_NAME, MODULE_ID } from 'constants/settings';
import { readFileSync } from 'fs';
import moment from 'moment';

const authorizationKey = 'Basic 12C1F7EF9AC8E288FBC2177B7F54D';
export const senderAddress = 'SACH SO <sachso.mailer@gmail.com>';
const bccAddress = 'tungnt@ames.edu.vn';

const client = axios.create({
  baseURL: `${sachsoServerUrl}/api/v1/aws/ses`,
  timeout: 10000,
  headers: {
    Authorization: authorizationKey,
    ApplicationName: APPLICATION_NAME,
    'Content-Type': 'application/json',
  },
});

export const sendEmail = (subject: string, htmlBody: string, receiverAddress: string, ccAddress: string) => {
  const data = {
    senderAddress,
    receiverAddress,
    ccAddress,
    bccAddress,
    subject,
    textBody: htmlBody,
    htmlBody,
  };

  return new Promise((resolve, reject) => {
    client
      .post('/send', data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// API này đã bị remove
export const sendTemplatedEmail = (receiverAddress: string, ccAddress: string, templateName: string, templateData: any) => {
  const data = {
    senderAddress,
    receiverAddress,
    ccAddress,
    bccAddress,
    templateName,
    templateData,
  };

  return new Promise((resolve, reject) => {
    client
      .post('/send-templated-email', data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const sendRawEmail = (subject: string, htmlBody: string, receiverAddress: string, ccAddress: string) => {
  const base64String = readFileSync('/path/to/file.jpg', { encoding: 'base64' });

  const data = {
    senderAddress,
    receiverAddress,
    ccAddress,
    bccAddress,
    subject,
    textBody: htmlBody,
    htmlBody,
    base64StringItems: {
      base64String,
      fileName: 'ket-qua-hoc-tap.pdf',
    },
  };

  return new Promise((resolve, reject) => {
    client
      .post('/send-raw-email', data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const sendRegisterEmail = (parameters = {}, applicationName = APPLICATION_NAME): Promise<any> => {
  return new Promise<any>((resolve, reject) => {
    axios({
      url: `${sachsoServerUrl}/api/v1.0/sendemail/sendemail-template`,
      method: 'POST',
      headers: {
        Authorization: authorizationKey,
        ApplicationName: applicationName,
        'Content-Type': 'application/json',
      },
      data: {
        parameters,
      },
    })
      .then((response) => {
        resolve(response.data.results);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const sendEmailV2 = async (email = '', password = '', templateName = '', ccAddress: '', bccAddress: '', applicationName = 'EBM', senderEmail = 'AMES ENGLISH <sachso.mailer@gmail.com>') => {
  return amesSendMail({
    to: email,
    isSendFast: true,
    cc: ccAddress,
    bcc: bccAddress,
    subject: '',
    templateMail: templateName,
    templateData: {
      userName: email,
      password: password,
    },
    senderAddress: senderEmail,
    applicationName: applicationName,
  });
};

export function amesSendMail({ to = '', isSendFast = false, cc = '', bcc = '', subject = '', templateMail = '', templateData = {}, senderAddress = 'AMES ENGLISH <sachso.mailer@gmail.com>', applicationName = 'EBM' }): Promise<any> {
  const dateNo = moment().format('YYYYMMDDhhmm');
  const dataSendMail = {
    to: to.toLowerCase(),
    isSendFast,
    cc,
    bcc,
    moduleId: MODULE_ID,
    subject: `${subject} #${dateNo}`,
    body: '',
    bodyHTML: '',
    attachment: '',
    templateName: templateMail,
    sourceInfo: `API Save Email - ${templateMail}`,
    templateData: JSON.stringify({
      ...templateData,
      dateNo: dateNo,
    }),
    mailer: senderAddress,
  };
  return new Promise<any>((resolve, reject) => {
    axios({
      url: 'https://toeic.ames.edu.vn/ames/api/amesapi/saveEmail',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: authorizationKey,
        ApplicationName: applicationName,
        'Content-Type': 'application/json',
      },
      data: dataSendMail,
    })
      .then((res) => {
        if (res.data?.Message === 'OK') resolve(res.data);
        else reject(res.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
}
